<template>
  <div class="bg-warning-soft py-4 px-4 md:px-8">
    <header class="mb-2">
      <h4 class="text-xl font-bold">Acceso para el acompañante</h4>
      <p class="text-slate-700 leading-tight">El acceso a las instalaciones se realizará mediante tarjeta y opcionalmente podrá configurar el reconocimiento facial a través de este equipo.</p>
    </header>
    <base-message-box>
      <template slot="content">
        <p>Se ha producido un error en el <strong>proceso de la fotografía</strong>. Para continuar con la activación del reconocimiento facial ha de repetir el proceso.</p>
      </template>
    </base-message-box>

    <base-button mode="primary" custom="w-full my-4" text="Repetir el proceso de configuración" @click="reset" />
  </div>
</template>

<script>
export default {
  name: 'BiometricAccessError',
  methods: {
    reset: function () {
      this.$emit('reset')
    }
  }
}
</script>
